import { ButtonFlavor, ButtonSize, ButtonType, ExButton } from '@boomi/exosphere';
import classNames from 'classnames';
import AnimatedLink from '../common/AnimatedLink';
import { useApp } from '../common/AppProvider';
import { translations } from '../translations/translations';

const TaskEditorFooter = ({
    onSave,
    onTest,
    taskId,
    isEditingTask,
}: {
    onSave: () => void;
    onTest: () => void;
    taskId: string | undefined;
    isEditingTask: boolean;
}) => {
    const { language, isOnline } = useApp();

    const footerClasses = classNames('task-editor-footer', {
        'existing-task': !!taskId,
    });

    return (
        <div className={footerClasses}>
            {/* history button */}
            {taskId && (
                <AnimatedLink
                    to={`../tasks/history?taskId=${taskId}`}
                    tabIndex={-1}
                    className="history-link"
                >
                    <ExButton
                        className="history-button exo-button"
                        flavor={ButtonFlavor.BASE}
                        size={ButtonSize.LARGE}
                        type={ButtonType.TERTIARY}
                    >
                        {translations[language].TASK_log_history}
                    </ExButton>
                </AnimatedLink>
            )}

            {/* test button */}
            <ExButton
                className="test-button exo-button"
                flavor={ButtonFlavor.BASE}
                size={ButtonSize.LARGE}
                type={ButtonType.SECONDARY}
                onClick={onTest}
                disabled={!isOnline || isEditingTask}
            >
                {translations[language].TASK_test}
            </ExButton>

            {/* save button */}
            <ExButton
                className="save-button exo-button"
                flavor={ButtonFlavor.BASE}
                size={ButtonSize.LARGE}
                type={ButtonType.PRIMARY}
                onClick={onSave}
                disabled={!isOnline || isEditingTask}
            >
                {translations[language].TASK_save}
            </ExButton>
        </div>
    );
};

export default TaskEditorFooter;
